import type { RescueCase } from "@io-spoke/contracts/rescue";
import { ChevronDown, ScanSearch } from "lucide-react";
import { Button } from "../ui/button";
import { RescueRadarCard } from "./RescueRadarCard";

type ToolsProps = {
  totalLabel: string;
  onAnalyze: () => void;
};

export function RescueRoomTools({ totalLabel, onAnalyze }: ToolsProps) {
  return (
    <details className="group relative shrink-0">
      <summary className="flex min-h-11 cursor-pointer list-none items-center gap-2 rounded-xl px-3 text-xs font-medium text-muted-foreground hover:bg-muted focus-visible:outline focus-visible:outline-2 [&::-webkit-details-marker]:hidden">
        Tools
        <ChevronDown
          className="h-3.5 w-3.5 transition-transform group-open:rotate-180 motion-reduce:transition-none"
          aria-hidden="true"
        />
      </summary>
      <div className="absolute right-0 z-20 mt-2 w-60 max-w-[calc(100vw-3rem)] space-y-4 rounded-2xl border bg-popover p-4 text-popover-foreground shadow-xl">
        <div>
          <p className="text-xs text-muted-foreground">
            Annual account value under review
          </p>
          <p className="mt-1 text-xl font-semibold tabular-nums">
            {totalLabel}
          </p>
        </div>
        <Button type="button" className="min-h-11 w-full" onClick={onAnalyze}>
          <ScanSearch className="h-4 w-4" aria-hidden="true" />
          Open Evidence Lab
        </Button>
      </div>
    </details>
  );
}

type AccountPickerProps = {
  cases: RescueCase[];
  selectedId: string;
  onSelect: (id: string) => void;
};

export function RescueAccountPicker({
  cases,
  selectedId,
  onSelect,
}: AccountPickerProps) {
  return (
    <details className="group rounded-2xl border bg-card">
      <summary className="flex min-h-14 cursor-pointer list-none items-center justify-between gap-3 rounded-2xl px-5 py-4 text-sm font-medium focus-visible:outline focus-visible:outline-2 [&::-webkit-details-marker]:hidden">
        Choose another account · {cases.length}
        <ChevronDown
          className="h-4 w-4 shrink-0 text-muted-foreground transition-transform group-open:rotate-180 motion-reduce:transition-none"
          aria-hidden="true"
        />
      </summary>
      <aside aria-label="Rescue Radar" className="border-t">
        {cases.map((item) => (
          <RescueRadarCard
            key={item.id}
            rescueCase={item}
            selected={item.id === selectedId}
            onSelect={() => onSelect(item.id)}
          />
        ))}
      </aside>
    </details>
  );
}
